module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-v2"
  }, [_c('div', {
    staticClass: "comment-proper"
  }, [_c('div', {
    staticClass: "comment-avatar"
  }, [(_vm.comment.author) ? _c('avatar', {
    attrs: {
      "username": _vm.comment.author.displayName,
      "src": _vm.comment.author.avatar,
      "backgroundColor": "#A2A3A6"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.comment.author) ? _c('avatar', {
    attrs: {
      "username": "anon",
      "backgroundColor": "#A2A3A6"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "comment-body"
  }, [(_vm.comment.author) ? _c('div', {
    staticClass: "comment-author"
  }, [_vm._v(_vm._s(_vm.comment.author.displayName))]) : _vm._e(), _vm._v(" "), (!_vm.comment.author) ? _c('div', {
    staticClass: "comment-author"
  }, [_vm._v("Anonymous")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "comment-time"
  }, [_vm._v(_vm._s(this.$data.relative))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.comment.body)
    }
  })])]), _vm._v(" "), _vm._l((_vm.comments), function(child) {
    return _c('div', {
      key: child.uuid
    }, [_c('comment', {
      class: {
        child: true
      },
      attrs: {
        "comment": child
      }
    })], 1)
  }), _vm._v(" "), (_vm.child && !_vm.isOpen) ? _c('p', {
    staticClass: "toggle-form",
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("reply")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }]
  }, [_c('comment-form', {
    attrs: {
      "contentUuid": _vm.contentUuid,
      "contentType": _vm.contentType,
      "parentUuid": _vm.comment.uuid,
      "client": _vm.client,
      "authorUuid": _vm.authorUuid,
      "siteUuid": _vm.siteUuid
    },
    on: {
      "new-comment": _vm.addComment
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-846ecc32!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/molecules/comment/comment.vue
// module id = 703
// module chunks = 4